import React from "react";
import { Player } from '@lottiefiles/react-lottie-player';
import { StringUtils, DateUtils } from '../utils';
import { getItem } from '../Storage';
import '../css/salient.css';
import '../css/chat.css';

export default class ChatMessage extends React.Component {

  constructor(props) {
    super(props);
  }

  determine_has_link = (message_text) => {
    let has_link = false;
    let link_url = '';
    let link_regex = /(https?:\/\/[^\s]+)/g;
    if (message_text.match(link_regex)) {
      has_link = true;
      link_url = message_text.match(link_regex)[0];
    }
    return { has_link, link_url };
  }

  return_text_content = (message) => {
    let message_text = message && message.content && message.content.text ? message.content.text : '';
    let is_sent      = message && message.is_sent   ? true   : false;
    let sender       = message.sender && message.sender.first_name ? message.sender : {};
    let time_string  = message.created_at ? DateUtils.getHoursString(message.created_at) +  ':'  + DateUtils.getMinutesString(message.created_at) + ' ' + DateUtils.getAMPMString(message.created_at) : '';
    let sender_name  = StringUtils.displayName(sender);
    let bubble_class = 'chat-bubble ' + (is_sent ? 'is-sent' : 'is-received');
    let link_div     = null;

    let { has_link, link_url } = this.determine_has_link(message_text);

    if (has_link) {
      link_div = <span className='chat-bubble-link' onClick={() => window.open(link_url, '_blank')}>{ link_url }</span>
    }

    return <div className={ bubble_class }>
      { !is_sent && sender_name ? <span className='chat-bubble-sender'>{ sender_name }</span> : null }
      <span className='chat-bubble-text'>{ message_text }</span>
      { link_div }
      { time_string ? <span className='chat-bubble-time'>{ time_string }</span> : null }
    </div>
  }

  return_image_content = (message) => {
    let image_url = message && message.content && message.content.url ? message.content.url : '';
    return <img className='chat-media-img' src={image_url} alt='' />
  }

  return_video_content = (message) => {
    let video_url = message && message.content && message.content.url ? message.content.url : '';
    return <video className='chat-media-video' controls>
      <source src={video_url} type="video/mp4" />
      Sorry, your browser doesn't support this video format.
    </video>
  }

  return_pdf_content = (message) => {
    let pdf_url = message && message.content && message.content.url ? message.content.url : '';
    return <a href={pdf_url} target="_blank" rel="noreferrer" className='chat-pdf sln-pressable'>
      <span className='fas fa-file-pdf chat-pdf-icon' />
      <span className='chat-pdf-name'>PDF Attachment</span>
    </a>
  }

  return_bubble_message = () => {
    return <div className='chat-typing'>
      <Player autoplay loop src={ require('../animations/grey-typing-bubbles.json') } style={{ height: '40px', width: '40px' }} />
    </div>
  }

  render_message_content = (message) => {
    switch (message.type) {
      case 'BUBBLE':
        return this.return_bubble_message(message);
      case 'TEXT':
        return this.return_text_content(message);
      case 'IMAGE':
        return this.return_image_content(message);
      case 'VIDEO':
        return this.return_video_content(message);
      case 'PDF':
        return this.return_pdf_content(message);
      default:
        return null;
    }
  }

  render_message = () => {
    let message = this.props.message || {};
    let from_id = message.from;
    let user_id = getItem('user_id');
    let is_sent = from_id === user_id;
        message = { ...message, is_sent: is_sent }

    let row_class = 'chat-row ' + (is_sent ? 'is-sent' : 'is-received');

    return <div className={ row_class }>
      { this.render_message_content(message) }
    </div>
  }

  render() {
    return this.render_message();
  }
}
